import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { ERROR_COLOR, PP_ACCENT_ONE_COLOR, PP_LINK_MAIN_COLOR } from '@/styles';
import { getLinkStateStyles, primaryTextButtonStyles } from '../Common';

const ErrorContainer = styled.div`
  display: flex;
  margin: 18px 0 12px;
  padding: 0 4px;
`;

const ErrorMessage = styled.p`
  color: ${ERROR_COLOR};
  font-size: 14px;
  line-height: 1.43;
  margin-left: 6px;
`;

const MarginSeparator = styled.div`
  margin-bottom: 1rem;
`;

const CenteredLinkText = styled.div`
  margin-bottom: 0.375rem;
`;

const LinkButtonStyles = css`
  padding: 0;
  margin-bottom: 0.375rem;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const PlusLinkButton = styled.button`
  ${({ theme }) => primaryTextButtonStyles(theme)}
  ${({ theme }) => getLinkStateStyles(theme)}
  ${() => LinkButtonStyles}

  svg {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 6px;
  }

  svg g g {
    fill: ${PP_LINK_MAIN_COLOR};
  }

  &:hover,
  &:active {
    svg g g {
      fill: ${PP_ACCENT_ONE_COLOR};
    }
  }
`;

const MinusLinkButton = styled.button`
  ${({ theme }) => primaryTextButtonStyles(theme)}
  ${({ theme }) => getLinkStateStyles(theme)}
  ${() => LinkButtonStyles}

  svg {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 6px;
  }

  svg path {
    fill: ${PP_LINK_MAIN_COLOR};
  }

  &:hover,
  &:active {
    svg path {
      fill: ${PP_ACCENT_ONE_COLOR};
    }
  }
`;

export {
  ErrorContainer,
  ErrorMessage,
  MarginSeparator,
  MinusLinkButton,
  PlusLinkButton,
  CenteredLinkText,
};
